import { useActiveServices as useActiveServicesQuery } from '@commenda/api';
import type { GetAllServicesForCompanyResponseType } from '@commenda/types/src/company/types';
import { useConfig } from 'context/useConfig';
import { useMemo } from 'react';

export type ActiveService =
  GetAllServicesForCompanyResponseType['services'][number];

interface IUseActiveServicesResult {
  services: ActiveService[];
  isLoading: boolean;
  error: unknown;
}

export const useActiveServices = (): IUseActiveServicesResult => {
  const { companyId } = useConfig();

  const { data, error } = useActiveServicesQuery(companyId ?? 0);

  const services = useMemo(
    () =>
      (data?.services ?? []).filter(
        (service) => service.status !== 'Completed'
      ),
    [data?.services]
  );

  const isLoading = !!companyId && !data && !error;

  return { services, isLoading, error };
};
